import { useMemo } from "react"
import ListItemDropDown from "components/list-item-dropdown"
import { METRIC_OPTIONS } from "helpers/metrics/definitions"
import { useAnalytics } from "connected-components/analytics"
import { FACTORS_VIEW_EVENTS } from "../../analytics/events"
import PeriodDisplay from "connected-components/dashboard/components/period-display"
import { useFactorsViewTemplateChart } from "../../hooks/use-factors-view-template-chart"
import { FACTORS_VIEW_PERFORMANCE_TEMPLATE_KEY, FACTORS_VIEW_PERFORMANCE_DEFAULTS } from "../template-chart-config"

export default function PerformanceHeader() {
  const { selectedMetricDisplay, setSelectedMetricDisplay } = useFactorsViewTemplateChart(
    FACTORS_VIEW_PERFORMANCE_TEMPLATE_KEY,
    FACTORS_VIEW_PERFORMANCE_DEFAULTS,
  )
  const analytics = useAnalytics()

  const metricOptions = useMemo(() => METRIC_OPTIONS.factorPerformance.map(({ id, label }) => ({ id, primaryText: label })), [])

  const handleDisplayMetricChange = (metricDisplay) => {
    analytics.track(FACTORS_VIEW_EVENTS.DISPLAY_METRIC_SELECTED, { metricDisplay })
    setSelectedMetricDisplay(metricDisplay)
  }

  return <>
    <PeriodDisplay />
    <ListItemDropDown
      label="Display"
      value={selectedMetricDisplay}
      setValue={handleDisplayMetricChange}
      options={metricOptions}
      alignMenu="left"
      disablePortal
    />
  </>
}

PerformanceHeader.propTypes = {}
